import { createAction } from 'typesafe-actions'

import { Id } from 'src/types'

import { PartnerHotelActionTypes, ResponseDataRequests } from './types'

type Options = {
  page?: number
  partner_id?: Id
  request_agency_ids?: string[]
  request_ids?: string[]
}

export const getPartnerHotels = createAction(
  PartnerHotelActionTypes.GET_PARTNER_HOTELS,
  action =>
    (
      options = {
        page: 1,
        partner_id: '',
        request_ids: [],
        request_agency_ids: []
      } as Options
    ) =>
      action({ options })
)

export const getPartnerHotelsFailure = createAction(
  PartnerHotelActionTypes.GET_PARTNER_HOTELS_FAILURE,
  action => (message: string) => action({ message })
)

export const getPartnerHotelsSuccess = createAction(
  PartnerHotelActionTypes.GET_PARTNER_HOTELS_SUCCESS,
  action =>
    ({ partner_hotels }: ResponseDataRequests) =>
      action({ partner_hotels })
)

export const sendPartnerHotel = createAction(
  PartnerHotelActionTypes.SEND_PARTNER_HOTEL,
  action =>
    (partner_hotel: {
      partner_id: Id
      hotel_id: Id
      partner_hotel_number: Number
      hotel_class: 'AGREEMENT' | 'PREFERABLE'
      hotel_image_url: String
      brand_name: String
      pool: Boolean
      laundry: Boolean
      parking: Boolean
      restaurant: Boolean
      refundable: Boolean
      nights: Number
      information: String
      category_stars: Number
      partner_hotels: []
    }) =>
      action({ partner_hotel })
)

export const sendPartneHotelFailure = createAction(
  PartnerHotelActionTypes.SEND_PARTNER_HOTEL_FAILURE,
  action => (message: string) => action({ message })
)

export const sendPartneHotelSuccess = createAction(
  PartnerHotelActionTypes.SEND_PARTNER_HOTEL_SUCCESS,
  action => () => action()
)
